import { useQuery } from 'react-query'
import { PaginatedRequest } from '../../../core/interfaces'
import { OpportunityFilter } from '../../../entities'
import { getAllOpportunities } from '../../opportunities'

export default function useOpportunities(
  query: PaginatedRequest<OpportunityFilter>
) {
  const { data, error, isLoading, isFetching, isPreviousData } = useQuery(
    ['opportunities', query],
    () => getAllOpportunities(query),
    {
      keepPreviousData: true
    }
  )
  return { data, error, isLoading, isFetching, isPreviousData }
}
